import {Component, EventEmitter, OnInit, Output} from "@angular/core";
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {CommonModule} from '@angular/common';
import {FieldResource, PossibleValueResource} from "../../core/modules/openapi";
import {MatSelectModule} from "@angular/material/select";
import {MatOptionSelectionChange} from "@angular/material/core";

@Component({
  selector: 'app-visibility-group-selector',
  imports: [MatFormFieldModule, MatSelectModule, ReactiveFormsModule, CommonModule],
  templateUrl: './visibility-group-selector.component.html',
  standalone: true,
  styleUrl: './visibility-group-selector.component.sass'
})
export class VisibilityGroupSelectorComponent implements OnInit {
  field: FieldResource;
  group: FormGroup;
  @Output() visibilityGroupChanged: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }
  ngOnInit() { }

  updateVisibility($event: MatOptionSelectionChange, item: PossibleValueResource) {
    if ($event.isUserInput) {
      let possibleValue = item;
      if (possibleValue.visibilityGroupSelector) {
        this.visibilityGroupChanged.emit(possibleValue.visibilityGroupSelector);
      }
    }
  }
}
